import { portalLoginPath } from '@/utils/portal-login-path';

const authGuard = (meta) => meta.dispatch(authGuardAction(meta));

const authGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	const checkPath = [
		"/login",
		"/forget-password",
		"/forget-password/success",
		"/reset-password",
		"/reset-password/success",
		"/sign-up",
		"/reset-2fa"
	];

	if (!state.auth.loggedIn && !(checkPath.includes(to?.location?.currentPath)) ) {
		const currentPath = to?.location?.currentPath;
		if (process.env.REACT_APP_SHELL_HOSTED === 'true' && typeof window !== 'undefined') {
			// currentPath is basename-stripped and query-less; the portal navigates with
			// this value verbatim, outside this router — so send the full browser URL.
			const search = window.location.search || '';
			const fullPath = `${process.env.PUBLIC_URL || ''}${currentPath}`;
			const returnUrl = currentPath && currentPath !== '/' ? `?returnUrl=${encodeURIComponent(fullPath + search)}` : '';
			window.location.assign(portalLoginPath(returnUrl));
			return null;
		}
		if (currentPath && currentPath !== '/') {
			return `/login?returnUrl=${encodeURIComponent(currentPath)}`;
		}
		return '/login'
	}

	return null
}

export { authGuard };
